import { useContext, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { UserContext } from 'Context/user';

export const TRADE_DISCONTINUED_PATH = '/trade-discontinued';

export const useTradeDiscontinuedRedirect = () => {
  const { userState: user } = useContext(UserContext);
  const { pathname } = useLocation();
  const history = useHistory();

  const isLoggedIn = Number.isInteger(user?.id);
  const isTradeSeller = isLoggedIn && user?.channel === 'trade';

  const isAlreadyOnDiscontinuedPage = pathname === TRADE_DISCONTINUED_PATH;

  useEffect(() => {
    if (isTradeSeller && !isAlreadyOnDiscontinuedPage) {
      history.replace(TRADE_DISCONTINUED_PATH);
    }
  }, [history, isAlreadyOnDiscontinuedPage, isTradeSeller]);
};
